
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/software-development",
      function () {
        return require("private-next-pages/us/software-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/software-development"])
      });
    }
  